import React, { useEffect, useRef, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
// import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import Table from "../../../Components/Table/Table";
import {
  SearchFilter,
  // ProDropFilter,
  FilterButton,
  CalendarFilter,
  ProDropFilter,
} from "../../../Components/Search/Search";
import Pagination from "../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router";
import { URL } from "../../../../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { TableActions } from "../../../Components/Misc/Actions";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import {
  ApproveJobListing,
  CancelJobListing,
  DeclineJobListing,
  GetJobListing,
} from "../../../../../utils/redux/HR/HRSlice";
import { toast } from "react-toastify";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { DEFINED_PERMISSIONS } from "../../../../../utils/const";

export default function RecruitmentProcessOverview() {
  const {
    searchText,
    filter,
    pageSize,
    currentPage,
    setSearchText,
    setFilter,
    // setPageSize,
    // setCurrentPage,
    date,
    setDate,
    find,
    findSearch,
  } = useSearchFilter({
    initialFilter: 1,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(false);

  const job_title_data = useSelector(
    (state) => state?.hr?.job_listing?.responseObject?.pageItems || []
  );

  const payload = {
    pageSize: 10,
    pageNumber: 1,
    ApprovalStatusEnum: filter,
  };

  useEffect(() => {
    dispatch(GetJobListing(payload));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pageSize,
    currentPage,
    find,
    searchText,
    FormatDateTime(date?.from, "DD/MM/YYYY"),
    FormatDateTime(date?.to, "DD/MM/YYYY"),
    refresh,
  ]);

  const filterBy = [
    { name: "Pending", filter: 1 },
    { name: "Approved", filter: 0 },
    { name: "Rejected", filter: 4 },
    { name: "Declined", filter: 7 },
    { name: "Cancelled", filter: 11 },
    { name: "Approved By PJL", filter: 12 },
    { name: "Approved By EDO", filter: 30 },
    { name: "Approved By MD", filter: 10 },
  ];

  const [modalAction, setModalAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);
  const [selectedPayrollId, setSelectedPayrollId] = useState(null);
  const [comment, setComment] = useState("");

  const handleOpenModal = (action, payrollId) => {
    setModalAction(action);
    setSelectedPayrollId(payrollId);
    setShowModal(true);
  };

  const handleModalActionButtonClick = () => {
    if (comment === "") {
      toast.error("Comment is required");
      return;
    }
    // Logic to handle action button click (Approve, Decline, Cancel) in the modal
    if (selectedPayrollId && modalAction) {
      const payload = {
        jobListingId: selectedPayrollId, // Replace selectedPayrollId with componentId
        comment: comment,
        approvalDesignation: 0,
      };

      let actionDispatchFunction;

      switch (modalAction) {
        case "Approve":
          actionDispatchFunction = ApproveJobListing;
          break;
        case "Decline":
          actionDispatchFunction = DeclineJobListing;
          break;
        case "Cancel":
          actionDispatchFunction = CancelJobListing;
          break;
        default:
          break;
      }

      if (actionDispatchFunction) {
        dispatch(actionDispatchFunction(payload))
          .then((res) => {
            if (res?.payload?.successful === true) {
              // Do something upon successful action
              toast.success(res?.payload?.statusMessage);
              setRefresh(!refresh);
              setShowModal(false);
              setComment("");
            } else if (res?.payload?.successful === false) {
              // Do something upon failed action
              toast.error(res?.payload?.statusMessage);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  };

  const handleCloseModal = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleCloseModal);
    return () => {
      document.removeEventListener("mousedown", handleCloseModal);
    };
  }, []);

  const [matchedPermissionHr, setMatchedPermissionHr] = useState("");

  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
    const hrPerm = [
      DEFINED_PERMISSIONS.SeniorHRManager,
      DEFINED_PERMISSIONS.PrimaryHRManager,
      // DEFINED_PERMISSIONS.HRManager,
    ];

    // Check if userPerm exists and matches any permission in hrPerm
    if (userPerm && userPerm.some((perm) => hrPerm.includes(perm))) {
      const matchedPerm = userPerm.find((perm) => hrPerm.includes(perm));
      setMatchedPermissionHr(matchedPerm); // Set matchedPermissionHr to the matched permission
    } else {
      setMatchedPermissionHr(""); // Reset to empty string if not matched
    }
  }, []);

  return (
    <PageStyle hasBack={false} isMain={false}>
      <div className={DashboardStyle.iflex} style={{ marginBottom: "20px" }}>
        <h3 className={DashboardStyle.textg}>Recruitment Process</h3>

        <div className={DashboardStyle.flexy}>
          {/* <div className={DashboardStyle.sele}>
            <select
              onChange={(e) => {
                const value = e.target.value;
                if (value === "SJL") {
                  navigate(`/dashboard/hr/${URL.Recruitment_Service}`);
                } else if (value === "Applicant") {
                  navigate(
                    `/dashboard/hr/${URL.Recruitment_Service}/${URL.Job_Application}`
                  );
                } else if (value === "PJL") {
                  navigate(
                    `/dashboard/hr/${URL.Recruitment_Service}/${URL.Recruitment_Process_Review}`
                  );
                }
              }}
            >
              <option value="SJL">SJL</option>
              <option value="PJL">PJL</option>
              <option value="Applicant">Applicant</option>
            </select>
          </div> */}

          <div className={DashboardStyle.sele}>
            <select
              onChange={(e) => {
                const value = e.target.value;
                if (value === "SJL") {
                  navigate(
                    `/dashboard/hr/${URL.Recruitment_Service}/${URL.Recruitment_Process}`
                  );
                }
                // else if (value === "Applicant") {
                //   navigate(
                //     `/dashboard/hr/${URL.Recruitment_Service}/${URL.Job_Application}`
                //   );
                // }
                else if (value === "PJL") {
                  navigate(
                    `/dashboard/hr/${URL.Recruitment_Service}/${URL.Recruitment_Process_Review}`
                  );
                } else if (value === "ED") {
                  navigate(
                    `/dashboard/hr/${URL.Recruitment_Service}/${URL.Recruitment_Process_Ed}`
                  );
                } else if (value === "MD") {
                  navigate(
                    `/dashboard/hr/${URL.Recruitment_Service}/${URL.Recruitment_Process_Md}`
                  );
                }
              }}
            >
              <option value="SJL">SJL</option>
              <option value="PJL">PJL</option>
              <option value="ED">ED</option>
              <option value="MD">MD</option>
            </select>
          </div>

          <button
            onClick={() =>
              navigate(
                `/dashboard/hr/${URL.Recruitment_Service}/${URL.Initiate_Recruitment}`
              )
            }
            className={DashboardStyle.greenButton}
          >
            {" "}
            New Process
          </button>
        </div>
      </div>
      <form className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          value={searchText}
          text={(searchText) => setSearchText(searchText)}
        />

        <CalendarFilter
          date={(date) => setDate(date)}
          name="Select Date Range"
          startDate={date?.from}
          endDate={date?.to}
        />

        <ProDropFilter
          filter={filter}
          setFilter={setFilter}
          name={"Filter"}
          filterBy={filterBy}
        />

        <FilterButton onClick={() => findSearch()} name="" />
      </form>

      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              <th>Initiator Name</th>
              <th>Job Title</th>
              <th>Years of Experience</th>
              <th>Opening Date</th>
              <th>Closing Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {job_title_data?.map((data) => (
              <tr key={data.id}>
                {/* Display job title */}
                <td>{data?.initiatorName || "N/A"}</td>

                <td>{data?.jobTitle?.title || "N/A"}</td>

                {/* Display years of experience */}
                <td>{data?.yearsOfExperience || "N/A"}</td>

                {/* Display opening date */}
                <td>
                  {data?.openingDate
                    ? new Date(data.openingDate).toLocaleDateString()
                    : "N/A"}
                </td>

                {/* Display closing date */}
                <td>
                  {data?.closingDate
                    ? new Date(data?.closingDate).toLocaleDateString()
                    : "N/A"}
                </td>

                {/* Application Channel */}
                <td>{data.approvalStatusEnum || "N/A"}</td>

                {/* Actions */}
                <td>
                  <TableActions
                    hasChildren={true}
                    // url={`../../${URL.Recruitment_Service}/${URL.Recruitment_Comment}`}
                    url={`../../${URL.Recruitment_Service}/${URL.Recruitment_Process_Details}/${data.id}`}
                  >
                    {data.approvalStatusEnum === "Pending" && [
                      {
                        name: "Update",
                        action: () => {
                          navigate(
                            `/dashboard/hr/${URL.Recruitment_Service}/${URL.Update_Recruitment}/${data.id}`
                          );
                        },
                      },
                    ]}
                  </TableActions>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <Pagination />
      {showModal && (
        <div className={DashboardStyle.modalOverlay}>
          <div className={DashboardStyle.modal1} ref={modalRef}>
            <div className={DashboardStyle.modalcontent1}>
              <div className={DashboardStyle.cycler}>
                <AiOutlineExclamationCircle
                  size={24}
                  style={{ color: "brown" }}
                />
              </div>
              <h1 style={{ textAlign: "center", fontSize: "20px" }}>
                {modalAction === "Approve"
                  ? "Approve process"
                  : modalAction === "Decline"
                  ? "Decline"
                  : modalAction === "Cancel"
                  ? "Cancel"
                  : ""}
              </h1>

              <div className={DashboardStyle.textyarea}>
                <label>
                  Comment <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  rows={6}
                  value={comment}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                  }}
                  onChange={(e) => setComment(e.target.value)}
                >
                  Enter Comment
                </textarea>
              </div>
            </div>

            <div className={DashboardStyle.modalfooter1}>
              <button
                className={DashboardStyle.greenButton}
                onClick={handleModalActionButtonClick}
              >{`Yes, ${modalAction}`}</button>
              <button
                onClick={() => setShowModal(false)}
                className={DashboardStyle.whiteButton2}
              >
                No, Close
              </button>
            </div>
          </div>
        </div>
      )}
    </PageStyle>
  );
}
